import { render, staticRenderFns } from "./SessionPanel.vue?vue&type=template&id=b7b65018&scoped=true"
import script from "./SessionPanel.vue?vue&type=script&lang=js"
export * from "./SessionPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b65018",
  null
  
)

export default component.exports